import React, { useEffect } from "react";
import { Box, Grid, Stack, Chip, Button, IconButton, Typography, useTheme, Tooltip, AvatarGroup, Avatar, Select, MenuItem, FormControl } from "@mui/material";
import TextareaAutosize from '@mui/material/TextareaAutosize';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import { useQuery } from "@tanstack/react-query";
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { FormattedMessage, useIntl } from "react-intl";
import messages from "../messages";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
//Controls
import AxionControls from "../../../components/controls/AxionControls";
import { tokens } from "../../../assets/theme";
import { useState } from "react";
import dayjs from "dayjs";


const BookingInformation = (props) => {
    const [instanceGermany, setInstanceGermany] = useLocalStorage("InstanceGermany", false);
    const theme = useTheme();
    const { formatMessage } = useIntl();
    const colors = tokens(theme.palette.mode);
    const [returnTypeList, setReturnTypeList] = useState([{ id: 1, title: "Inlämning" }, { id: 2, title: "Upphämtning" }]);

    function formatDateFromTick(date) {
        let datePart = date ? new Date(date * 1000).toLocaleDateString('sv-SE') : "";
        return datePart;
    }
    function formatDateTimeFromTick(date) {
        let datePart = date ? new Date(date * 1000).toLocaleDateString('sv-SE') : "";
        let timePart = date ? new Date(date * 1000).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : "";
        return datePart + " " + timePart;
    }
    function formatDate(date) {
        return date ? new Date(date).toLocaleDateString('sv-SE') : "";
    }
    function formatTime(date) {
        return date ? new Date(date).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' }) : "";
    }
    function formatFullTime(date) {
        return date ? new Date(date).toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit', second: '2-digit' }) : "";
    }
    function formatFullDateTime(date) {
        let formattedDate = formatDate(date) + " " + formatFullTime(date);
        return formattedDate;
    }

    function getStatusText(status) {
        let statusText = "";
        switch (status) {
            case 1:
                statusText = formatMessage(messages.general_status1);
                break;
            case 2:
                statusText = formatMessage(messages.general_status2);
                break;
            case 999:
                statusText = formatMessage(messages.general_status999);
                break;
            case 3:
                statusText = formatMessage(messages.general_status3);
                break;
            case 4:
                statusText = formatMessage(messages.general_status4);
                break;
            case 9:
                statusText = formatMessage(messages.general_status9);
                break;
            case 10:
                statusText = formatMessage(messages.general_status10);
                break;
            default:
                statusText = formatMessage(messages.general_statusDefault);
                break;
        }
        return statusText;
    }

    function getBGColor(status) {
        let color = "";

        switch (status) {
            case 1:
                color = "#ffeb3b"; //yellow
                break;
            case 2:
                color = "#009688"; //teal
                break;
            case 999:
                color = "#ff9800"; //orange
                break;
            case 3:
                color = "#ff9800"; //orange
                break;
            case 4:
                color = "#4caf50"; //green
                break;
            case 9:
                color = "#4caf50"; //blue
                break;
            case 10:
                color = "#f30000"; //blue
                break;
            default:
                color = ""; //no color
                break;

            //color = "#2196f3"  //blue
        }
        return color;
    }

    function getColor(status) {
        if (status === 1) {
            return "";
        } else {
            return "#ffffff";//colors.greenAccent[500];
        }
    }

    if (props.data === null) {
        return <Box color="white">Data is missing...</Box>;
    }

    const styles = theme => ({
        textField: {
            width: '90%',
            marginLeft: 'auto',
            marginRight: 'auto',
            paddingBottom: 0,
            marginTop: 0,
            fontWeight: 500
        },
        input: {
            color: 'white'
        }
    });

function calculateActualCashback() {
    let totalCashback = props.data?.refunded || 0;
    let freight = 0;
    if (props.data?.returnType === 2) {
        if (props.data?.returndrums?.filter(x => x.article.itemNo === "780000011")?.length > 0) {
            freight = 150;
        }
    }
    if (props.data?.returnType === 1) {
        freight = props.data?.returndrums?.filter(x => x.article.itemNo === "780000000")[0]?.drumcount || 0;
    }
    let actualCashback = totalCashback - freight;
    return totalCashback + " - " + freight + " = " + actualCashback; 
}

    // console.log("Data: ", props.data?.customer);

    let content = <>
        <Box color={colors.primary[100]}>

            <Grid container alignItems="center" width="100%" height="600px" direction="row" spacing="auto" padding="10px">
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_returnOrder} /></Typography></Grid>
                <Grid item xs={8}><Typography>{props.data?.returnid}</Typography></Grid>

                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>

                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_created} /></Typography></Grid>
                <Grid item xs={8}><Typography>{formatDateTimeFromTick(props.data?.created)}</Typography></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_updated} /></Typography></Grid>
                <Grid item xs={8}><Typography>{formatFullDateTime(props.data?.changedTs)} ({props.data?.changedBy})</Typography></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>

                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_supplierNumber} /></Typography></Grid>
                <Grid item xs={8}><Typography>{props.data?.customer.customerNo}</Typography></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_orgazationalNumber} /></Typography></Grid>
                <Grid item xs={8}><Typography>{props.data?.customer.ynumber}</Typography></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>

                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_supplier} />
                    {(props.data?.customer.status === 'UNVERIFIED' ) &&
                        <Tooltip title={<Typography fontSize="12px">Supplier is not verified.</Typography>}>
                            <Chip key={9} label=" ! " size='small' sx={{ backgroundColor: '#f30000', color: '#ffffff', width: '30px', marginLeft: '10px' }} />
                        </Tooltip>
                    }
                </Typography></Grid>
                <Grid item xs={8}>
                    <AxionControls.AxionTextBox name="customer.customername" id="customer.customername" label="" value={props.data?.customer.customername} sx={{ minWidth: '100%' }} onChange={props.handleChange} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_branchOffice} /></Typography></Grid>
                <Grid item xs={8}><Typography>{props.data?.customer.branchOffice}</Typography></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_email} /></Typography></Grid>
                <Grid item xs={8}>
                    <AxionControls.AxionTextBox name="email" id="email" label="" value={props.data?.email} sx={{ minWidth: '50%' }} onChange={props.handleChange} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_customerRef} /></Typography></Grid>
                {/* [Godsmärkning] */}
                <Grid item xs={8}>
                    <AxionControls.AxionTextBox name="customerRef" id="customerRef" label="" value={props.data?.customerRef} sx={{ minWidth: '50%' }} onChange={props.handleChange} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>

                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_typeOfBooking} /></Typography></Grid>
                <Grid item xs={8}>
                    <AxionControls.AxionSelect name="returnType" id="returnType" label="Type of booking" value={props.data?.returnType} options={returnTypeList} sx={{ width: '240px' }} />

                </Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_status} /></Typography></Grid>
                <Grid item xs={8} sx={{ height: '40px' }} display="flex" alignItems="center">
                    <Chip key={9} label={getStatusText(props.data?.statusid)} size='small' sx={{ backgroundColor: getBGColor(props.data?.statusid), color: getColor(props.data?.statusid) }} />
                </Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>

                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_returnPoint} /></Typography></Grid>
                <Grid item xs={8}><AxionControls.AxionTextBox name="returnpoint.pointname" id="returnpoint.pointname" label="" value={props.data?.returnpoint.pointname} sx={{ minWidth: '50%' }} onChange={props.handleChange} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>

                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_returnInformation} /></Typography></Grid>
                <Grid item xs={8}>
                    <TextareaAutosize
                        minRows={2}
                        value={props.data?.information.replaceAll("<br />", "\n")}
                        style={{ minWidth: '100%' }}
                        onChange={props.handleChange}
                        ame="information"
                        id="information"
                    >

                    </TextareaAutosize>
                    {/* <AxionControls.AxionTextBox name="information" id="information" label="" value={props.data?.information} sx={{ minWidth: '100%' }} onChange={props.handleChange} /> */}
                </Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                {!instanceGermany && <>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_estimatedCashback} /></Typography></Grid>
                    <Grid item xs={8}><Typography>{calculateActualCashback()} SEK</Typography></Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                </>}
                
                <Grid item xs={4}><Typography><FormattedMessage {...messages.bookingInformation_erpOrderNumber} /></Typography></Grid>
                {(props.data?.pyramidOrderno === null ) ? <Grid item xs={8} sx={{ height: '40px' }} display="flex" alignItems="center"><Chip key={9} label="Order missing in ERP" size='small' sx={{ backgroundColor: '#f30000', color: '#ffffff' }} /></Grid> : <Grid item xs={8}><Typography>{props.data?.pyramidOrderno}</Typography></Grid>}
               
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
               
            </Grid>
        </Box>
    </>;

    return (
        <>
            {content}
        </>
    )
};

export default BookingInformation;
